/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'

interface TableHeadColumnInnerWrapperProps {
    className?: string
    children: React.ReactNode | React.ReactNode[]
}

const TableHeadColumnInnerWrapper = (props: TableHeadColumnInnerWrapperProps) => {
    return (
        <div
            className={clsx(
                'TableHeadColumnInnerWrapper flex flex-col h-full justify-start min-w-0',
                props.className && props.className
            )}
        >
            {props.children}
        </div>
    )
}

export default TableHeadColumnInnerWrapper
